/**
 * App router
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Routes
import { routes } from '../routes';

// Import views
import Error404 from './views/errors/Error404';
import Error500 from './views/errors/Error500';
import ErrorConfig from './views/errors/ErrorConfig';
import Home from './views/home/Home';
import PLGReport from './views/reports/PLGReport';
import SessionExpired from './views/errors/ErrorExpired';
import SignIn from './views/account/SignIn';
import PublicStart from './views/home/PublicStart';
import TakeAssessment from './views/assessment/TakeAssessment';
import Unauthorized from './views/errors/ErrorUnauthorized';

const Router = class Router extends React.Component {
  render() {
    return (
      <Route
        render={({ location }) => (
          <Switch location={location}>
            <Route
              exact
              path={routes.index}
              render={routing => <Home {...routing} {...this.props} />}
            />

            <Route
              path={routes.signIn}
              render={routing => <SignIn {...routing} {...this.props} />}
            />

            <Route
              path={routes.publicStart}
              render={routing => <PublicStart {...routing} {...this.props} />}
            />

            <Route
              path={routes.takeAssessment}
              render={routing => <TakeAssessment {...routing} {...this.props} />}
            />

            <Route
              path={routes.reviewAssessment}
              render={routing => <TakeAssessment {...routing} {...this.props} review={true} />}
            />

            <Route
              path={routes.report}
              render={routing => <PLGReport {...routing} {...this.props} />}
            />

            <Route
              path={routes.unauthorized}
              render={routing => <Unauthorized {...routing} {...this.props} />}
            />

            <Route
              path={routes.expired}
              render={routing => <SessionExpired {...routing} {...this.props} />}
            />

            <Route
              path={routes.serverError}
              render={routing => <Error500 {...routing} {...this.props} />}
            />

            <Route
              path={routes.configError}
              render={routing => <ErrorConfig {...routing} {...this.props} />}
            />

            <Route render={routing => <Error404 {...routing} {...this.props} />} />

          </Switch>
        )}
      />
    );
  }
};

export default Router;
